import { render, staticRenderFns } from "./parte-de-trabajo.vue?vue&type=template&id=765e2750"
import script from "./parte-de-trabajo.vue?vue&type=script&lang=js"
export * from "./parte-de-trabajo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports